import React from 'react';
import styles from './SearchDropdown.module.scss';

const SearchDropdownItem = ({objectData, handleSelectItem, setShowBtn}) => {
  return (
    <div
      onClick={() => {
        handleSelectItem({id: objectData.id, name: objectData.name, hex: objectData.hex});
        setShowBtn(true);
      }}
      className={styles.dropdown_item_wrapp}>
      <img src={`/img/user/${objectData?.img}.svg`} alt="" />
      <p className={styles.dropdown_item_text}>{objectData.name}</p>
    </div>
  );
};

export default SearchDropdownItem;
